import React from 'react'

const SignupIcon = ({ className = '', ...props }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none"
      className={`transition-colors duration-200 ${className}`}
      {...props}
    >
      <path 
        d="M18.18 8.04011L18.643 7.57611C19.0116 7.20733 19.5117 7.00009 20.0331 7C20.5546 6.99991 21.0547 7.20696 21.4235 7.57561C21.7923 7.94426 21.9995 8.44431 21.9996 8.96576C21.9997 9.4872 21.7926 9.98733 21.424 10.3561L20.961 10.8201M18.18 8.04011C18.18 8.04011 18.238 9.02411 19.107 9.89311C19.976 10.7621 20.961 10.8201 20.961 10.8201M18.18 8.04011L13.92 12.3001C13.63 12.5881 13.486 12.7331 13.362 12.8921C13.2153 13.0801 13.0906 13.2821 12.988 13.4981C12.901 13.6801 12.837 13.8731 12.708 14.2601L12.295 15.5001L12.161 15.9011M20.961 10.8201L16.701 15.0801C16.411 15.3701 16.267 15.5141 16.108 15.6381C15.92 15.7848 15.718 15.9094 15.502 16.0121C15.32 16.0991 15.127 16.1631 14.74 16.2921L13.5 16.7051L13.099 16.8391M12.161 15.9011L12.028 16.3031C11.997 16.3964 11.9926 16.4965 12.0152 16.5922C12.0379 16.6879 12.0867 16.7754 12.1562 16.8449C12.2257 16.9144 12.3132 16.9632 12.4089 16.9859C12.5046 17.0085 12.6047 17.0041 12.698 16.9731L13.099 16.8391M12.161 15.9011L13.099 16.8391" 
        stroke="currentColor" 
        strokeWidth="1.5"
      />
      <path 
        d="M8 13H10.5M8 9H14.5M8 17H9.5M19.828 3.172C18.657 2 16.771 2 13 2H11C7.229 2 5.343 2 4.172 3.172C3.001 4.344 3 6.229 3 10V14C3 17.771 3 19.657 4.172 20.828C5.344 21.999 7.229 22 11 22H13C16.771 22 18.657 22 19.828 20.828C20.772 19.885 20.955 18.48 20.991 16" 
        stroke="currentColor" 
        strokeWidth="1.5" 
        strokeLinecap="round"
      />
    </svg>
  )
}

export default SignupIcon
